import React from 'react';
import { isEmpty } from 'lodash';

import { Toast } from "@kaleyra/kds";

import WebURLIcon from "../../assets/WebsiteurlIcon.svg"
import QuickReplyIcon from "../../assets/QuickreplyIcon.svg"
import CallIcon from "../../assets/CallIcon.svg";
import { WMS_API_URL } from '../../base';

type routeType = "overview" | "create" | "edit" | "details";

const apiKey = localStorage.getItem('KLR_FE_TOKEN');
const sid = localStorage.getItem('KLR_FE_SID');
const accessToken = localStorage.getItem('ACCESS_TOKEN');

export const fbCustomHeaders = {
    "api-key": apiKey,
    "sid": sid,
    "skip-token": 1,
    "Authorization": `Bearer ${accessToken}`
}

export type selectedActionType = "deleteFallback" | "update" | "saveDraft" | "deleteChannel" | "unpublish";

export const MIN_TITLE_LENGTH = 3, MAX_TITLE_LENGTH = 75, MAX_DELAY = 900, MIN_DELAY = 5;

export const WHATSAPP_CHANNEL = "whatsapp";
export const SMS_CHANNEL = "sms";
export const PUBLISHED = "published", DRAFT = "draft", DELETED = "deleted", UPDATING = "updating", PENDING="_pending", 
DLT_PNDNG = "deleted_pending", PUB_PNDNG = "published_pending", DFT_PNDNG = "draft_pending";

export const pollURL = `${WMS_API_URL}/${sid}/fallbacks`;
export const waCreateTemplateUrl = "/whatsapp/templates";
export const smsCreateTemplateUrl = "/channels/sms/templates";
// Change it with s3 bucket url's 
// export const mediaApiUrl = "http://localhost:8081/v1/files/KaleyraNew/files";
// export const baseMediaUrl = "http://localhost:8081";
export const mediaApiUrl = "";
export const baseMediaUrl = "";
export const viewDocUrl = "https://developers.kaleyra.io/docs/home-kaleyra-cloud-developer-hub"


export const getWhatsappTemp = (waTempData: any, tempName: string | undefined, getTranslation: boolean = true, waba_id: string | undefined) => {
    if (!isEmpty(waTempData) && tempName) {
        const template = waTempData?.find((temp: any) => temp.name === tempName && temp.waba_id === waba_id);
        if (getTranslation)
            return template?.translation[0];
        else
            return template;
    }
    return {};
}

export const getWhatsappNumb = (waNumbData: any, findByNumberId: boolean, from: string | undefined) => {
    if (!isEmpty(waNumbData) && from) {
        if (findByNumberId) {
            return waNumbData?.numbers?.find((temp: any) => temp.id === from);
        } else {
            return waNumbData?.numbers?.find((item: any) => item.waba_id === from);
        }
    }
    return {};
}

export const getSmsNumb = (msgNumbData: any, findByNumberId: boolean, from: string | undefined) => {
    if (!isEmpty(msgNumbData) && from) {
        if (findByNumberId) {
            return msgNumbData?.find((data: any) => data.id == from);
        } else {
            return msgNumbData?.find((item: any) => item.sender === from);
        }
    }
    return {};
}

export const getSMSTemp = (msgTempData: any, tempId: string | undefined) => {
    if (!isEmpty(msgTempData) && tempId)
        return msgTempData?.find((temp: any) => temp.id.toString() === tempId);
    return {};
}

export const redirect = (route: routeType, history: any, flwName: string = "", flwId: string = "") => {
    let url = '/fallback/overview';

    if (route === "details")
        url = `/fallback/overview/${flwName}?id=${flwId}`;
    else if (route === "edit")
        url = `/fallback/overview/${flwName}/edit?id=${flwId}`;
    else
        url = '/fallback/overview/create';

    history.push(url);
}

export const redirectToOverview = (history: any) => {
    history.replace('/fallback/overview');
}

export const getButtonsArr = (waTemplate: any) => {
    const buttonsArr: any = [];

    if (waTemplate) {
        Object.entries(waTemplate).map(([key, value]) => {
            const typedKey: string = key;
            const typedValue: any = value;

            if ((key.startsWith("quick_reply_button") || ["call_button_text", "website_button_text"].includes(typedKey)) && typedValue !== null) {
                buttonsArr.push({
                    children: <p className='linktext justify-content-center mb-0'>{typedValue}</p>,
                    key: typedKey,
                    icon: <img
                        src={
                            typedKey.startsWith("quick_reply_button") ? QuickReplyIcon :
                                typedKey === "website_button_text" ? WebURLIcon :
                                    CallIcon
                        }
                        alt="buttonIcon"
                    />,
                })
            }
        })
    }
    return buttonsArr;
}

export const getPlaceHolderImg = (template: any) => {
    if (template) {
        switch (template.header_content_type) {
            case "2": return "img";
            case "3": return "doc";
            case "6": return "video";
            default: return undefined;
        }
    }
    return undefined;
}

export const handleNewTab = (url: string) => {
    const newWindow = window.open(url, '_blank', 'noopener,noreferrer');
    if (newWindow) newWindow.opener = null;
}

export const displayToast = (title: string, msg: string, type: any, buttonObject: any) => {

    return Toast(
        {
            title: title,
            message: msg,
            closable: false,
            delay: 5,
        },
        {
            type: type,
            leftIcon: true,
        },
        {
            ...buttonObject
        },
        {
            title: '',
            props: {},
        },
    );
}

export const getVariableCount = (data: any) => {
    const uniqueVars = [...new Set(data?.match(/\{[^{}]+\}/g))];
    return uniqueVars.length;
}

export const getStatus = (t: any, status: string) => {
    if (status?.includes(PENDING))
        status = "updating";

    const getTextType = () => {
        switch (status) {
            case UPDATING:
                return ([t("fbUpdating"), "warning"]);
            case DRAFT:
                return [t("mainDraft"), "info"];
            case PUBLISHED:
                return [t("mainPublished"), "success"];
            case DELETED:
                return [t("mainDeleted"), "info"];
            default: return ["", ""];
        }
    }
    const [tagText, tagType] = getTextType();

    return { tagText, tagType };


}

export const getChannels = (fallBackData: any, waNumbData: any, waTempData: any, msgNumbData: any, msgTempData: any, getPrevValue: boolean = false) => {
    // getPrevValue = true => get previously published values
    // getPrevValue = false => get stagingDocument
    

    // Previous value for a flow with no staging document is undefined
    if (getPrevValue && !fallBackData?.stagingDocument)
        return undefined;

    // Assign main document values
    const data = fallBackData?.document?.data;
    let channelsData = [data?.send1, data?.send2];

    // Reassign with staging doc values if getPrevValue is false
    if (fallBackData.stagingDocument && !getPrevValue) {
        const stagingData = fallBackData?.stagingDocument?.data;
        channelsData = [stagingData?.send1, stagingData?.send2];
    }

    const channels: any = [];

    channelsData.map((chan: any) => {
        if (!chan) {
            channels.push(undefined);
        }
        else {
            const isWhatsapp = chan?.channel === WHATSAPP_CHANNEL;
            let fromName, fromNum, wabaId, tempName, variableNum, description, mediaUrl = undefined;

            if (isWhatsapp) {
                const numbDetail = waNumbData?.numbers?.filter((numb: any) => numb.id === chan.from);
                const tempDetail = getWhatsappTemp(waTempData, chan?.template, false, numbDetail?.[0]?.waba_id);
                const tempTranslation = tempDetail ? tempDetail?.translation : [];
                if (chan.mediaFiles.length !== 0) {
                    mediaUrl = `${baseMediaUrl}${chan.mediaFiles[0].cmsPath}`
                }
                fromName = numbDetail ? numbDetail[0]?.name : "";
                tempName = tempDetail ? tempDetail?.name : "";
                description = tempTranslation?.length > 0 ? tempTranslation[0]?.body : "";
                fromNum = '+' + numbDetail?.[0]?.country_code + numbDetail?.[0]?.phone_number;
                wabaId = numbDetail?.[0]?.waba_id;
                variableNum = tempTranslation?.length > 0 ? Number(tempTranslation[0]?.total_params) : 0;
            }
            else {
                const numbDetail = msgNumbData?.filter((numb: any) => String(numb.id) === chan.from);
                const tempDetail = getSMSTemp(msgTempData, chan.template);
                fromName = numbDetail ? numbDetail[0]?.sender : "";
                description = tempDetail ? tempDetail.content : "";
                tempName = tempDetail ? tempDetail?.title : "";
                variableNum = getVariableCount(tempDetail ? tempDetail?.content : "");
            }

            channels.push({
                ...chan,
                fromName,
                mediaUrl,
                tempName,
                fromNum,
                description,
                wabaId,
                variableNum,
            });
        }
    })

    return channels;
}